export default __webpack_public_path__ + "static/media/1835.fc98cb49.png";